import { Button, Flex } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { STATUS } from 'projectConstants';
import { getCalculationLoadingStatus, getEditInstrumentData } from 'redux/DashboardSliceV2';

interface Properties {
  handleCreate: () => void;
  handleCancel: () => void;
}

const DashboardModalButtons = ({ handleCreate, handleCancel }: Properties) => {
  const isLoading = useSelector(getCalculationLoadingStatus);
  const editInstrumentData = useSelector(getEditInstrumentData);
  return (
    <Flex
      bgColor='white'
      borderTop='1px solid #E8E9EB'
      height='79px'
      alignItems='center'
      justifyContent='flex-end'
      p='18px'
      gap='14px'
    >
      <Button
        flex={1}
        h='100%'
        bg='white'
        border='1px solid #D9D9D9'
        borderRadius='11px'
        fontFamily='Roboto Regular'
        fontWeight='500'
        fontSize='13px'
        color='#121826'
        transition='transform 0.1s ease, background 0.15s ease'
        _hover={{ bg: 'gray.50' }}
        _active={{ transform: 'scale(0.97)' }}
        onClick={handleCancel}
      >
        Cancel
      </Button>

      <Button
        flex={1}
        h='100%'
        bg='#8B5CF6'
        borderRadius='11px'
        fontFamily='Roboto Regular'
        fontWeight='500'
        fontSize='13px'
        color='white'
        transition='transform 0.1s ease, background 0.15s ease'
        _hover={{ bg: '#7C4DEF' }}
        _active={{ transform: 'scale(0.97)' }}
        onClick={handleCreate}
        disabled={
          !(isLoading === STATUS.SUCCESS || isLoading === STATUS.IDLE) ||
          !editInstrumentData ||
          !editInstrumentData?.instrument_indicators?.length
        }
      >
        Save Changes
      </Button>
    </Flex>
  );
};

export default DashboardModalButtons;
